import { FruitNinjaRemoteComboFx } from './FruitNinjaRemoteComboFx.tsx';
import { FruitNinjaRemoteGameOver } from './FruitNinjaRemoteGameOver.tsx';
import { FruitNinjaRemoteHud } from './FruitNinjaRemoteHud.tsx';
import { FruitNinjaRemotePause } from './FruitNinjaRemotePause.tsx';

/** In adapter: DOM shell for fruit-ninja-without-score; canvas is in `CanvasRenderer`. */
export function FruitNinjaRemoteTvOverlays() {
  return (
    <>
      <FruitNinjaRemoteHud />
      <FruitNinjaRemoteComboFx />
      <FruitNinjaRemotePause />
      <FruitNinjaRemoteGameOver />
    </>
  );
}
